import React, { useContext, useState } from "react";
import { Box } from "@mui/material";

import { Calendar, dateFnsLocalizer } from "react-big-calendar";

import "react-big-calendar/lib/css/react-big-calendar.css";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import enUS from "date-fns/locale/en-US";

import CreateBookingModal from "../Bookings/CreateBooking";
import { BookingDataContext } from "../useBookingData";
import useNotificationProvider from "hooks/notificationBar/useNotificationProvider";
import { ProgressCircular } from "components";
import axios from "axios";
import styles from "./Calendar.module.css"; // Import the CSS module

const locales = {
    "en-US": enUS,
};

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
});

const API_BASE_URL = "/api2.0/CANWebsiteV3";

const AvailableTimesList = ({ availableTimes }) => {
    const { notifySuccess, notifyError } = useNotificationProvider();
    const eventStyleGetter = (event, start, end, isSelected) => {
        let newStyle = {
            backgroundColor: "lightblue",
            color: "black",
            borderRadius: "0px",
            border: "none",
            display: "flex",
            padding: "2px 5px",
            fontSize: "0.85em",
            marginBottom: "10px", // Add space between events
        };

        return {
            className: styles.event,
            style: newStyle,
            title: event.title,
        };
    };

    const {
        fetchAvailableTimes,
        fetchBookingsWithAvailableTimes,
        isLoadingBooking,
    } = useContext(BookingDataContext);

    // const groupedByDate = availableTimes.reduce((groupedTimes, time) => {
    //     const [year, month, day] = time.Date.split("T")[0]
    //         .split("-")
    //         .map(Number);
    //     const date = new Date(year, month - 1, day);
    //     const dateString = date.toLocaleDateString();

    //     if (!groupedTimes[dateString]) {
    //         groupedTimes[dateString] = [];
    //     }
    //     groupedTimes[dateString].push(time);

    //     return groupedTimes;
    // }, {});
    const dayStyleGetter = (date) => {
        return {
            style: {
                height: "100px", // Increase height of each date cell
                backgroundColor: "white", // Optional: change background color
                padding: "10px 20px",
            },
        };
    };

    const events = availableTimes.map((time) => {
        const [year, month, day] = time.Date.split("T")[0]
            .split("-")
            .map(Number);
        const startTimeParts = time.start_time.split(":").map(Number);
        const endTimeParts = time.end_time.split(":").map(Number);

        const startDate = new Date(year, month - 1, day, ...startTimeParts);
        const endDate = new Date(year, month - 1, day, ...endTimeParts);

        return {
            title: `${time.start_time
                .split(":")
                .slice(0, 2)
                .join(":")} - ${time.end_time
                .split(":")
                .slice(0, 2)
                .join(":")}`,
            start: startDate,
            end: endDate,
            allDay: false,
            resource: time,
        };
    });

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedAvailableTime, setSelectedAvailableTime] = useState(null);

    const handleSaveBooking = async (bookingDetails) => {
        // Use the selectedAvailableTime state for the AvailableTimeId
        const bookingData = {
            UserEmail: bookingDetails.UserEmail, // Assuming this comes from a form or input
            AvailableTimeId: selectedAvailableTime.Id, // Make sure to use the correct property name for ID
            Status: "confirmed", // Assuming the status is always set to "confirmed" upon booking
        };

        try {
            const response = await axios.post(
                `${API_BASE_URL}/AddBooking`,
                bookingData
            );
            if (response.status === 200) {
                // Check if the request was successful
                console.log("Booking saved successfully");
                notifySuccess("Booking saved successfully!");
                fetchAvailableTimes(); // Refresh available times
                fetchBookingsWithAvailableTimes(); // Refresh bookings list
            } else {
                // Handle non-successful responses
                console.error("Failed to save booking", response.data);
                notifyError("Failed to save booking.");
            }
        } catch (error) {
            // Handle errors from the request itself (e.g., network errors)
            console.error("Failed to save booking:", error);
            notifyError("Failed to save booking.");
        }

        setModalOpen(false); // Close the modal regardless of the outcome
    };

    console.log(
        events.map((event) => ({
            title: event.title,
            start: event.start.toString(),
            end: event.end.toString(),
        }))
    );

    return (
        <Box sx={{ flexGrow: 1, border: "2px solid red", minWidth: "1000px" }}>
            {isLoadingBooking && <ProgressCircular />}
            {modalOpen && (
                <CreateBookingModal
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    onSave={handleSaveBooking}
                    availableTime={selectedAvailableTime}
                />
            )}
            <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500, width: "100%" }}
                eventPropGetter={eventStyleGetter}
                dayPropGetter={dayStyleGetter}
                onSelectEvent={(event) => {
                    setSelectedAvailableTime(event.resource);
                    setModalOpen(true);
                }}
                components={{
                    timeGutterHeader: () => (
                        <div
                            style={{
                                border: "2px solid red",
                                height: "100%",
                                display: "none",
                            }}
                            className={styles.timeGutter}
                        ></div>
                    ),
                    timeGutter: () => (
                        <div
                            style={{
                                border: "2px solid black",
                                height: "100%",
                            }}
                            className={styles.timeGutter}
                        ></div>
                    ),
                    timeContent: ({ children }) => (
                        <div
                            style={{
                                border: "2px solid green",
                                height: "100%",
                            }}
                            className={styles.timeContent}
                        >
                            {children}
                        </div>
                    ),
                }}
            />
        </Box>
    );
};

export default AvailableTimesList;
